<div class="rooms-view-toggle">
  <button class="view-btn" [class.active]="!showShipMap" (click)="showShipMap = false">List</button>
  <button class="view-btn" [class.active]="showShipMap" (click)="showShipMap = true">Map</button>
</div>

<div class="filter-bar">
  <input class="filter-input" [(ngModel)]="roomSearch" placeholder="Search rooms…" autocomplete="off">
  <label class="filter-checkbox-label">
    <input type="checkbox" [(ngModel)]="hideNonCombatRooms">
    Hide non-combat rooms
  </label>
</div>

<!-- Ship visual map -->
<div class="ship-map-zoom-bar" *ngIf="showShipMap">
  <button class="zoom-btn" (click)="zoomOut()" [disabled]="cellSize <= 12" title="Zoom out">&#8722;</button>
  <span class="zoom-label">{{ cellSize }}px</span>
  <button class="zoom-btn" (click)="zoomIn()" [disabled]="cellSize >= 80" title="Zoom in">&#43;</button>
</div>
<div class="ship-map-wrap" *ngIf="showShipMap"
     [class.dragging]="mapDragging"
     (mousedown)="onMapMouseDown($event)"
     (mousemove)="onMapMouseMove($event)"
     (mouseup)="onMapMouseUp()"
     (mouseleave)="onMapMouseLeave()"
     (wheel)="onMapWheel($event)"
     (touchstart)="onMapTouchStart($event)"
     (touchmove)="onMapTouchMove($event)"
     (touchend)="onMapTouchEnd($event)"
     style="touch-action:none;">
  <div class="ship-grid"
       [style.grid-template-columns]="'repeat(' + shipGridCols + ', ' + cellSize + 'px)'"
       [style.grid-template-rows]="'repeat(' + shipGridRows + ', ' + cellSize + 'px)'"
       [style.width.px]="shipGridCols * cellSize"
       [style.height.px]="shipGridRows * cellSize"
       [style.background-image]="shipHullSpriteUrl() ? 'url(' + shipHullSpriteUrl() + ')' : 'none'">
    <div class="room-tile room-type-{{ roomType(r.roomDesignId) | lowercase }}"
         *ngFor="let r of deployedRooms"
         [style.grid-column]="roomGridCol(r)"
         [style.grid-row]="roomGridRow(r)"
         [style.cursor]="roomSupportsAI(r.roomDesignId) || roomHasStatBoost(r.roomDesignId) ? 'pointer' : 'default'"
         [title]="roomName2(r.roomDesignId)"
         (click)="selectRoomIfNotDrag(r)">
      <pss-sprite *ngIf="roomSpriteId(r.roomDesignId)" class="room-tile-img" [spriteId]="roomSpriteId(r.roomDesignId)"></pss-sprite>
      <span class="room-tile-name">{{ roomName2(r.roomDesignId) }}</span>
    </div>
  </div>
</div>

<!-- Room list -->
<ng-container *ngIf="!showShipMap">
  <div class="room-list-header">
    <span class="room-lh-type sort-col" (click)="setRoomSort('type')">Type<span class="sort-ind">{{ roomSortBy === 'type' ? (roomSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
    <span class="room-lh-name sort-col" (click)="setRoomSort('name')">Name<span class="sort-ind">{{ roomSortBy === 'name' ? (roomSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
    <span class="room-lh-pos sort-col" (click)="setRoomSort('position')">Pos<span class="sort-ind">{{ roomSortBy === 'position' ? (roomSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  </div>
  <div class="room-list">
    <div class="room-row" *ngFor="let r of deployedRooms" (click)="roomSelected.emit(r)"
         [style.cursor]="roomSupportsAI(r.roomDesignId) || roomHasStatBoost(r.roomDesignId) ? 'pointer' : 'default'">
      <pss-sprite *ngIf="roomSpriteId(r.roomDesignId)" class="room-sprite" [spriteId]="roomSpriteId(r.roomDesignId)"></pss-sprite>
      <span class="room-type-badge room-type-{{ roomType(r.roomDesignId) | lowercase }}">{{ roomType(r.roomDesignId) || 'Room' }}</span>
      <span class="room-row-name">{{ roomName2(r.roomDesignId) }}</span>
      <span class="room-pos">R{{ r.row }}·C{{ r.col }}</span>
    </div>
  </div>
</ng-container>

<!-- DPS Calculator -->
<div class="dps-calc">
  <div class="dps-calc-toggle" (click)="showDpsCalc = !showDpsCalc">
    <span>DPS Calculator</span>
    <span>{{ showDpsCalc ? '▲' : '▼' }}</span>
  </div>
  <div class="dps-calc-body" *ngIf="showDpsCalc">
    <div class="dps-calc-grid">
      <div class="dps-field">
        <label class="dps-label">Base Reload Time (s)</label>
        <input class="dps-input" type="number" min="0.01" step="0.1" [(ngModel)]="dpsBaseReload">
      </div>
      <div class="dps-field">
        <label class="dps-label">Ammo Mod (%)</label>
        <input class="dps-input" type="number" min="1" step="1" [(ngModel)]="dpsAmmoMod"
               title="100 = no modifier; 200 = fires 2× as fast">
      </div>
      <div class="dps-field">
        <label class="dps-label">Crew Boost (%)</label>
        <input class="dps-input" type="number" min="0" step="1" [(ngModel)]="dpsCrewBoost"
               title="Combined weapon skill bonus of crew in this room">
      </div>
      <div class="dps-field">
        <label class="dps-label">Damage per Shot</label>
        <input class="dps-input" type="number" min="0" step="1" [(ngModel)]="dpsDamage">
      </div>
    </div>
    <div class="dps-ab-row">
      <input type="checkbox" id="dpsAbPresent" [(ngModel)]="dpsAbPresent">
      <label for="dpsAbPresent">AB Room touching</label>
      <input class="dps-input" type="number" min="0" step="1" [(ngModel)]="dpsAbBoost"
             style="width:5rem; margin-left:0.5rem;"
             [disabled]="!dpsAbPresent" title="AB room boost (%)">
      <span style="font-size:0.65rem; color:var(--text-dim);">% AB boost</span>
    </div>
    <div class="dps-results">
      <div class="dps-result-cell">
        <div class="dps-result-label">Fire Rate</div>
        <div class="dps-result-val">{{ dpsFormat(dpsFireRate) }} s</div>
      </div>
      <div class="dps-result-cell">
        <div class="dps-result-label">DPS</div>
        <div class="dps-result-val">{{ dpsFormat(dpsDps) }}</div>
      </div>
    </div>
    <div class="dps-formula-note">
      Formula: (Base / (Ammo × 0.01)) / ((Crew%/100 + 1) × (((AB%/100 + 1) × 15 × 0.01) + 1))
    </div>
  </div>
</div>
